import {LocationService} from "../../services/LocationService";
import {Location} from "../../entities/Location"
import { ServerImportModel } from "./ServerImportModel";
import { NotificationService } from "../../services/NotificationService";

export class ServerLocationImportModel extends ServerImportModel<Location>  {
    static $inject = ['$q', 'LocationService', 'NotificationService','$timeout'];
    name:string = "test";
    importType:string = "Location";

    constructor($q: ng.IQService,
        public locationService: LocationService,
        public notifyService: NotificationService,
        public timeout: ng.ITimeoutService) {
        super($q,locationService, notifyService, timeout);
    }
    getRoute(nextAction:string):string{
        return "admin.serverlocationimport."+nextAction;
    }
    getControllersName(): string {
        return "locations";
    }
}
